/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  AbstractSnapshotFormComponent,
  DateTimeTypes,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
  IS_REGION_AU_OR_NZ,
  whenCreateOrEditMode,
} from '@gh/common-shared';
import { STYLES_FLEX_COLUMN_LAYOUT } from '@gh/core-ui';
import { DrawDetailsLendersInfo, isNotFutureDate } from '../../../resources/draw-details.model';

@Component({
  standalone: false,
  selector: 'gh-draw-details-lenders-form',
  templateUrl: 'draw-details-lenders-form.component.html',
  styles: [STYLES_FLEX_COLUMN_LAYOUT],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawDetailsLendersFormComponent extends AbstractSnapshotFormComponent<DrawDetailsLendersInfo> {

  constructor(private formStateBuilder: FormStateBuilder) {
    super();
  }

  get toDateLabel(): string {
    return IS_REGION_AU_OR_NZ ? 'lbl_to_date_incl_gst' : 'lbl_to_date';
  }

  isDateAllowed(date: Date): boolean {
    return isNotFutureDate(date);
  }

  protected buildForm(snapshot: FormStateSnapshot<DrawDetailsLendersInfo>): FormState<DrawDetailsLendersInfo> {
    return this.formStateBuilder.buildPlain({
      mode: this.mode,
      enabled: whenCreateOrEditMode(),
      snapshot,
      children: {
        contractDrawnAmount: { enabled: false },
        variationsDrawnAmount: { enabled: false },
        totalDrawnAmount: { enabled: false },
        totalPaid: { enabled: false },
        totalBalance: { enabled: false },
        contractAmount: { enabled: false },
        contractAmountLenders: { enabled: false },
        accountingDate: {
          required: true,
          type: DateTimeTypes.ShortDate,
          // validators: [(control: AbstractControl) => validateNotFutureDate(control.value)],
        },
        isShowAllCostCenters: void 0,
        invoiceNumber: { enabled: false },
        invoiceSeqNumber: { enabled: false },
        costLendIncluded: { enabled: false },
        costLend: { enabled: false },
        drawRuleCode: void 0,
      },
    });
  }
}
